import { connect } from "react-redux";
import DetalleOrdenCompra from "./DetalleOrdenCompra";
import { actions } from "../../../../redux/modules/cuenta_pagar/cuenta_pagar";
import { print } from "../../../../redux/modules/print/print";

const ms2p = (state) => {
    return {
        ...state.cuenta_pagar,
        print_state: state.print,
    };
};

const md2p = {
    ...actions,
    print: (name) => (dispatch) => dispatch(print(name)),
};

export default connect(ms2p, md2p)(DetalleOrdenCompra);
